import React from 'react';

import { PasswordStrength, PasswordStrengthProps } from './passwordStrength';
// password profile:
// min 8 characters
// at least 1 upper case alphabet
// at least 1 lower case alphabet
// at least 1 number
// at least 1 of these !@#$%^&*()_-+= special characters

const rules = ['[a-z]', '[A-Z]', '[0-9]', '[!@#$%^&*()+\\-_=]'];

export type PasswordValidityCalculatorProps = {
  password: string;
};

export const PasswordValidityCalculator: React.FC<PasswordValidityCalculatorProps> = ({
  password,
}) => {
  const matches = rules.reduce(
    (acc, cur) => (new RegExp(cur).test(password) ? acc + 1 : acc),
    0
  );
  const score = (password.length > 7 && password.length < 17
    ? matches + 1
    : matches) as PasswordStrengthProps['score'];

  return <PasswordStrength score={score}></PasswordStrength>;
};
